import { useState, useCallback, useLayoutEffect } from 'react';
import { noop } from '../../../packages/@web-utilities/other/index.mjs';

function useOverflowMeasurements({
  containerNode,
  measurerNode,
  overflowOffsetWidth = 0
}) {
  const [childrenThatFit, setChildrenThatFit] = useState(0);
  const [parentWidth, setParentWidth] = useState(0);
  const [childWidths, setChildWidths] = useState([]);
  const remeasureElements = useCallback(() => {
    if (containerNode.current === null || measurerNode.current === null) {
      return;
    }
    setParentWidth(containerNode.current.offsetWidth);
    const measuredChildWidths = measureChildren(measurerNode.current);
    setChildWidths(measuredChildWidths);
  }, [containerNode, measurerNode]);
  useLayoutEffect(() => {
    if (!containerNode.current) {
      return;
    }
    let count = 0;
    for (let childrenWidth = 0; count <= childWidths.length; count++) {
      if (childrenWidth + childWidths[count] + overflowOffsetWidth <= parentWidth) {
        childrenWidth += childWidths[count];
      } else {
        break;
      }
    }
    setChildrenThatFit(count);
  }, [childWidths, parentWidth, containerNode, overflowOffsetWidth]);
  useLayoutEffect(() => {
    remeasureElements();
  }, [remeasureElements]);
  if (!containerNode.current) {
    return {
      parentWidth: 0,
      childWidths: [],
      childrenThatFit: 0,
      remeasureElements: noop
    };
  }
  return {
    parentWidth,
    childWidths,
    childrenThatFit,
    remeasureElements
  };
}
function measureChildren(node) {
  var _container$parentNode;
  const container = document.createElement('div');
  container.style.display = 'inline-block';
  container.style.position = 'absolute';
  container.style.visibility = 'hidden';
  container.style.zIndex = '-1';
  node.style.display = 'flex';
  const clonedNode = node.cloneNode(true);
  node.style.display = 'none';
  container.appendChild(clonedNode);
  document.body.appendChild(container);
  const measuredChildWidths = Array.from(container.firstChild.children).map(childElement => childElement.offsetWidth);
  (_container$parentNode = container.parentNode) == null ? void 0 : _container$parentNode.removeChild(container);
  return measuredChildWidths;
}

export { useOverflowMeasurements };
